import { Clause, LegalPage } from "@/pages/legal/LegalShell";
import { LEGAL_CONTACTS, PRIVACY_SECTIONS } from "@/lib/legal";

export default function Privacy() {
  return (
    <LegalPage
      title="Privacy, data usage & NDPA compliance"
      intro="How CARENEST handles personal, biometric, geolocation and health data — and the strict time limits on who can see a family's details."
      testId="privacy-page"
    >
      {PRIVACY_SECTIONS.map((s) => (
        <Clause key={s.title} heading={s.title} paras={s.paras} testId={`privacy-${s.title.slice(0, 2).trim()}`} />
      ))}

      <Clause
        heading="5. Your rights & contacting us"
        paras={[
          "Under the NDPA you may request access to the personal data we hold about you, ask for corrections, object to certain processing, or ask us to delete data we no longer need for a legal or contractual purpose.",
          `Data subject requests and privacy questions: ${LEGAL_CONTACTS.privacy}. Legal notices: ${LEGAL_CONTACTS.legal}.`,
          "Audit records of arrival verification, PIN entry and dispute evidence are retained as statutory evidence and may be disclosed to law enforcement, insurers or a tribunal where lawfully required.",
        ]}
        testId="privacy-rights"
      />
    </LegalPage>
  );
}
